import { defineMessages } from 'react-intl';

const translations = {
  page: {
    organisationFormSection: {
      title: {
        id: 'organisationFormSection.title',
        defaultMessage: 'Organisation',
        description: 'Title of the organisation form section',
      },
      search: {
        placeholder: {
          id: 'organisationFormSection.search.placeholder',
          defaultMessage: 'Search organisation',
          description:
            'Placeholder of the organisation search field in the organisation form section',
        },
      },
      button: {
        create: {
          label: {
            id: 'organisationFormSection.button.create.label',
            defaultMessage: 'New organisation',
            description: 'Label of the create button in the organisation form section',
          },
        },
      },
    },
    createOrganisation: {
      title: {
        id: 'createOrganisation.title',
        defaultMessage: 'New organisation',
        description: 'Title of the create new organisation drawer',
      },
    },
  },
  feedback: {
    organisationCreated: {
      id: 'createOrganisation.feedback.organisationCreated',
      defaultMessage: 'Organisation was created',
      description: 'feedback on the successful creation of an organisation',
    },
    organisationNotCreated: {
      id: 'createOrganisation.feedback.organisationNotCreated',
      defaultMessage: 'Organisation could not be created',
      description: 'feedback on a failed attempt to create an organisation',
    },
  },
};

export default defineMessages(translations);
